"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FilePlusSolid: function() {
        return FilePlusSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FilePlusSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM14 3.5L18.5 8H15C14.4477 8 14 7.55228 14 7V3.5ZM12 12C12.5523 12 13 12.4477 13 13V14.5H14.5C15.0523 14.5 15.5 14.9477 15.5 15.5C15.5 16.0523 15.0523 16.5 14.5 16.5H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V16.5H9.5C8.94772 16.5 8.5 16.0523 8.5 15.5C8.5 14.9477 8.94772 14.5 9.5 14.5H11V13C11 12.4477 11.4477 12 12 12Z",
        fill: "currentColor"
    })
}), "FilePlusSolid");
const _default = FilePlusSolid;
